// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2X9J6","title":"AfterFrontImage_title__3QrnQ"};